import styled from 'styled-components';

export const PriceFilterStyle = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	width: 100%;
	position: relative;
`;
